// @ts-ignore
export async function processLegalRequest(data: any) {
  // АНХААР: Өөрийнхөө шинэ түлхүүрээ доорх хашилтан дотор тавиарай!
  const API_KEY = "AIzaSyCpIhVaGkLw76IGLFkhCN2lgA2Psu96_w8"; 
  
  // ХАМГИЙН ЧУХАЛ: Ачаалал багатай, маш хурдан "gemini-2.5-flash" руугаа буцаж орлоо
  const URL = `https://generativelanguage.googleapis.com/v1beta/models/gemini-2.5-flash:generateContent?key=${API_KEY}`;

  try {
    const response = await fetch(URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        contents: [{ 
          parts: [{ 
            text: `Та бол Монгол Улсын туршлагатай, өндөр ур чадвартай хуульч, өмгөөлөгч юм. 
            Хэрэглэгчийн хүсэлт: [Төрөл: ${data.docType}, Үйлдэл: ${data.action}]
            Агуулга: ${data.input}

            Дараах шаардлагыг ХАТУУ баримталж хариулна уу:
            1. МЭРГЭЖЛИЙН БАЙХ: "Би хиймэл оюун ухаан тул..." гэх мэт илүүц үг, оршил БҮҮ ашигла. Шууд л үйлчлүүлэгчдээ зөвлөгөө өгч байгаа мэтээр мэндлээд эхэл.
            2. БҮТЭЦ: 
               - Эхлээд "⚖️ Хууль зүйн дүгнэлт ба Зөвлөгөө" (Гол анхаарах зүйлс, хуулийн заалтыг дурдах)
               - Дараа нь "📄 Баримт бичгийн загвар" (Нэхэмжлэл, гэрээ гэх мэт) гэж тодорхой 2 хуваах.
            3. ФОРМАТ: Уншихад маш хялбар байлгахын тулд Markdown ашиглах (## Том гарчиг, **Тод үг**, - Жагсаалт). Нуршуу, урт үргэлжилсэн текстээс зайлсхийж, зай авах.
            4. НАРИЙВЧЛАЛ: Улсын тэмдэгтийн хураамжийг хуулийн дагуу бодит үнийн дүнгээр тооцох.` 
          }] 
        }],
        generationConfig: {
          temperature: 0.3,
          maxOutputTokens: 8192
        }
      })
    });

    const result = await response.json();

    if (!response.ok) {
      console.error("API Error Details:", result);
      throw new Error(result.error?.message || "API Request Failed");
    }

    if (result.candidates && result.candidates[0].content) {
      return result.candidates[0].content.parts[0].text;
    } else {
      return "Уучлаарай, систем хариу боловсруулж чадсангүй.";
    }
  } catch (error: any) {
    console.error("Fetch Error:", error);
    return `Алдаа: ${error.message}`;
  }
}